import React from 'react';
import FadeIn from './FadeIn';
import SafeIcon from '../common/SafeIcon';
import { FiXCircle, FiCheckCircle } from 'react-icons/fi';

export default function Contrast() {
  return (
    <section className="py-16 px-4 sm:px-6 max-w-4xl mx-auto">
      <FadeIn>
        <h2 className="text-3xl font-bold text-slate-900 mb-10 text-center">Let's be clear about what this is.</h2>
        
        <div className="grid md:grid-cols-2 gap-8">
          <div className="p-8 rounded-2xl bg-red-50 border border-red-100">
            <h3 className="text-xl font-semibold text-red-900 mb-4 flex items-center">
              <SafeIcon icon={FiXCircle} className="mr-2 text-red-500" /> What this is NOT:
            </h3>
            <ul className="space-y-3 text-red-800/80">
              <li>• A "get-rich-quick" scheme</li>
              <li>• Complicated spreadsheet modeling</li>
              <li>• Crypto or investing advice</li>
              <li>• Guilt-trips about your spending habits</li>
              <li>• Unrealistic promises of instant wealth</li>
            </ul>
          </div>

          <div className="p-8 rounded-2xl bg-emerald-50 border border-emerald-100">
            <h3 className="text-xl font-semibold text-emerald-900 mb-4 flex items-center">
              <SafeIcon icon={FiCheckCircle} className="mr-2 text-emerald-500" /> What this IS:
            </h3>
            <ul className="space-y-3 text-emerald-800/80">
              <li>• A realistic system for right now</li>
              <li>• Simple, visible paycheck allocation</li>
              <li>• Strategies to avoid overdraft fees</li>
              <li>• A method to prioritize overdue bills</li>
              <li>• Calm, structured, emotional relief</li>
            </ul>
          </div>
        </div>
      </FadeIn>
    </section>
  );
}